import { axiosDS } from '@pp/axios'
import { SimpleResponse } from 'Types/simpleResponse'
import { ResponseCatalog, RequestParams } from 'Models'
import { urls } from 'Constants/Urls'
import {
	BgLimitRequest,
	BgLimitRequestCreate,
	BgLimitRequestFull,
	BgLimitRequestMeta,
	BgLimitRequestSaveModel,
	ClientLimitSupportInfoModel,
} from 'Pages/ibro'

export const bgLimitRequestApi = {
	getLimitRequestItems: async (params: RequestParams) => {
		const res = await axiosDS().get<ResponseCatalog<BgLimitRequest> & { meta: BgLimitRequestMeta }>(
			urls.broker.limit_request,
			{ params }
		)
		return res.data
	},

	getLimitRequest: async (id: number) => {
		const res = await axiosDS().get<BgLimitRequestFull>(`${urls.broker.limit_request}/${id}`)
		return res.data
	},

	createLimitRequest: async (data: BgLimitRequestCreate) => {
		const res = await axiosDS().post<BgLimitRequestFull>(urls.broker.limit_request, {
			data,
		})
		return res.data
	},

	limitRequestCheckLimit: async (id: number, amount: string) => {
		const res = await axiosDS().patch<BgLimitRequestFull>(
			urls.broker.limit_request_check_limit.replace(':id', id.toString()),
			{ data: { amount } }
		)
		return res.data
	},

	postLimitRequest: async (id: number) => {
		const res = await axiosDS().patch<BgLimitRequestFull>(
			urls.broker.limit_request_post_limit.replace(':id', id.toString())
		)
		return res.data
	},

	updateLimitRequest: async (id: number) => {
		const res = await axiosDS().patch<BgLimitRequestFull>(
			urls.broker.limit_request_update_limit.replace(':id', id.toString())
		)
		return res.data
	},

	updateLimit: async (data: BgLimitRequestSaveModel) => {
		const res = await axiosDS().patch<BgLimitRequestFull>(
			`${urls.broker.limit_request}/${data.id}`,
			{
				data,
			}
		)
		return res.data
	},

	saveLimitRequest: async (id: number, data: BgLimitRequestSaveModel) => {
		const res = await axiosDS().patch<BgLimitRequestFull>(
			urls.broker.limit_request_save_limit.replace(':id', id.toString()),
			{ data }
		)
		return res.data
	},

	checkLimitRequestStatus: async (id: number) => {
		const res = await axiosDS().patch<BgLimitRequestFull>(
			urls.broker.limit_request_check_status.replace(':id', id.toString())
		)
		return res.data
	},

	getClientLimit: async (inn: string) => {
		const res = await axiosDS().get<SimpleResponse>(`${urls.broker.get_client_limit}/${inn}`)
		return res.data
	},

	getClientLimitSupportInfo: async (inn: string) => {
		const res = await axiosDS().get<ClientLimitSupportInfoModel>(
			urls.broker.get_client_limit_support_info.replace(':inn', inn)
		)
		return res.data
	},
}
